export const parser = function(cssGradient,iconSize=1)
{
	if(!cssGradient.match(/(linear|radial)/))
		return false;

	let temp = [...cssGradient ? cssGradient.matchAll(/^(linear|radial)-gradient\((.*)\);?$/ig) : null];
	if(!temp.length)
		return false;

	const gradient = {
		type:null,
		orientation:0,
		steps:[],
		linearVector:{x1:0,y1:0,x2:1,y2:0}, // (x:0,y:0) => (x:1,y:0) // horizontal
		$:{
			chain:null,
			parts:null,
		},
	};

	gradient.type = temp?.[0]?.[1];
	gradient.$.chain = temp?.[0]?.[2];

	let noSplitparts = [...gradient.$.chain.matchAll(/\(([^)]+)\)/ig)]
	gradient.$.parts = gradient.$.chain;
	for(let i=0; i<noSplitparts.length; i++)
	{
		gradient.$.parts = gradient.$.parts.replace(noSplitparts[i][1],'#noSplitparts'+i+'#');
	}
	gradient.$.parts = gradient.$.parts.split(',');
	gradient.$.parts = gradient.$.parts.map((part, index) => {
		part = part.trim();
		for(let i=0; i<noSplitparts.length; i++)
		{
			part = part.replace('#noSplitparts'+i+'#',noSplitparts[i][1]);
		}
		return part;
	})

	gradient.$.parts.map((part, index) => {
		if(part.match(/(circle|ellipse)$/))
		{
			gradient.geometry = part;
		}
		else if(index==0 && (part.match(/^[0-9-]+deg$/) || part==='0'))
			gradient.orientation = parseInt(part.replace('deg',''));
		else if(part.match(/^.+ [0-9]+%/))
		{
			gradient.steps.push([
				part.replace(/^(.+) [0-9]+%/,'$1'),
				parseInt(part.replace(/^.+ ([0-9]+)%/,'$1')),
			])
		}
		else
		{
			gradient.steps.push(part)
		}
	})

	gradient.steps = gradient.steps.map((item,index) => {
		if(typeof item === "string")
		{
			let offset = 100*index/(gradient.steps.length-1);
			return [item,offset];
		}
		else
		{
			return item;
		}
	})

	if(gradient.type === 'linear')
	{
		const a = -gradient.orientation * Math.PI/180;
		let x2 = Math.round(Math.cos(a)*1000)/1000;
		let y2 = Math.round(Math.sin(a)*1000)/1000;
		let max = Math.max(Math.abs(x2),Math.abs(y2))
		x2 = (x2/max) / 2;
		y2 = (y2/max) / 2;
		let x1 = -x2 + 0.5;
		let y1 = -y2 + 0.5;
		x2 += 0.5;
		y2 += 0.5;
		gradient.linearVector = {
			x1: x1 * iconSize,
			y1: y1 * iconSize,
			x2: x2 * iconSize,
			y2: y2 * iconSize,
		};
	}

	return gradient;
}

export default parser